import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (props, ref) => <svg width={1792} height={1792} viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}><path d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z" /></svg>;
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;